import React, {ReactNode} from "react";
import {useSearchParams} from "react-router-dom";

type Props = {
  title: string,
  leftNav?: ReactNode,
  content: ReactNode
}


export const BookingFlowPage = (props: Props) => {
  
  const [searchParams] = useSearchParams();
  const version = searchParams.get('v') ?? undefined; // this is for testing
  
  return <div className={'AppSection WhiteSection'}>
    <div className={'AppSectionContent BookingOverlay'}>
      {version == 'DRAFT' && <div className={'DraftWarningSection'}>
        This is a preview of your booking flow! Some functionality is disabled.
      </div>}

      <div className={'BookingOverlayTopRow BookingOverlaySectionMargin'}>
        <div className={'BookingOverlayHeader'}><h2>{props.title}</h2></div>
      </div>

      <div className={'BookingOverlayBottomRow'}>
        {props.leftNav}
        <div className={'BookingOverlayBottomRight BookingOverlaySectionMargin'}>
          {props.content}
        </div>
      </div>
    </div>
  </div>;
}
